import React, { useEffect, useState } from 'react';
import ProofHeader from './ProofHeader';
import UnlockModal from './UnlockModal';
import { NativeProofData, Session } from '../services/api';

/** No rrweb fetch, no localStorage authorization, no persisted proof/contact payload. */
export default function NativeProof({ session }: { session: Session }) {
  const [proof, setProof] = useState<NativeProofData | null>(null);
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    const check = () => {
      const expiry = Date.parse(proof?.expirationDate || session.expirationDate || '');
      if (!Number.isFinite(expiry) || expiry <= Date.now()) { setProof(null); setExpired(true); }
    };
    check(); const timer = setInterval(check, 1000); return () => clearInterval(timer);
  }, [proof, session.expirationDate]);
  const time = (v: string | null) => v ? new Date(v).toLocaleString(undefined, { timeZone: 'UTC' }) + ' UTC' : 'Unavailable';
  return <div className="proof-layout">
    <ProofHeader session={session} isUnlocked={!!proof} onEndAccess={() => setProof(null)} />
    <main style={{ padding: 24, maxWidth: 960, width: '100%', boxSizing: 'border-box', margin: '0 auto', overflowWrap: 'anywhere' }}>
      <h1>Meta consent evidence</h1>
      <p>{session.verfiID} · No recording</p>
      {expired ? <p role="alert">This evidence has expired or is unavailable.</p> : proof ? <>
        <section><h2>What this evidence shows</h2>{proof.limitations.map(line => <p key={line}>{line}</p>)}</section>
        <dl>{[['Submitted (Meta)', proof.submittedAt], ['Received (Verfi)', proof.receivedAt], ['Retrieved (Verfi)', proof.retrievedAt], ['Retained until', proof.expirationDate]].map(([label, value]) => <div key={label || ''} style={{ marginBottom: 12 }}><dt>{label}</dt><dd style={{ marginLeft: 0 }}>{time(value)}</dd></div>)}</dl>
        {proof.incomplete && <p role="status">Evidence is incomplete. Missing responses are not acceptance.</p>}
        {proof.disclosures.map((d, i) => <section key={i} style={{ border: '1px solid #d1d5db', borderRadius: 8, padding: 16, marginBottom: 16 }}>
          <h2>{d.key} · {d.decision}</h2><p style={{ whiteSpace: 'pre-wrap' }}>{d.text || 'Disclosure wording unavailable'}</p>
          <p>{d.required === null ? 'Requirement unknown' : d.required ? 'Required disclosure' : 'Optional disclosure'} · Observed configuration</p>
        </section>)}
      </> : <p>Enter the email or phone number submitted with this lead to view its consent evidence.</p>}
    </main>
    {!expired && !proof && <UnlockModal verfiID={session.verfiID} session={session} onUnlock={value => { if (value?.verfiID === session.verfiID) setProof(value); }} />}
  </div>;
}
